import imgCavang from "../assets/images/HX01.png";
import imgSo from "../assets/images/HX02.png";
import imgCangu from "../assets/images/HX03.png";
import imgMuc from "../assets/images/HX04.png";
import imgTomhum from "../assets/images/HX05.png";
import imgcua from "../assets/images/HX06.png";
export const YOUTUBE_URL_GET_COOKIE = 'https://youtu.be/9aKU-wcBhYs?si=qCfjQkWlccDPoETw'
export const YOUTUBE_URL_MANUAL = 'https://youtu.be/98V2FhrIujA?si=GPYlMqqpp9cMeEvx'
export const SECRET_KEY = "67bc82f0-5ca8-8010-ac47-e8cde1e6cbd1";


export const SOCKET_EVENT = {
  UUID_NOTIFY_CREATED_TEAM_TROOP: "UUID_NOTIFY_CREATED_TEAM_TROOP",
  UUID_NOTIFY_JOINED_TEAM_TROOP: "UUID_NOTIFY_JOINED_TEAM_TROOP",
  UUID_NOTIFY_DONE_TEAM_TROOP: "UUID_NOTIFY_DONE_TEAM_TROOP",
  UUID_NOTIFY_UPDATE_RESOURCE: "UUID_NOTIFY_UPDATE_RESOURCE",
  UUID_NOTIFY_CANCELED_TEAM_TROOP: "UUID_NOTIFY_CANCELED_TEAM_TROOP",
  UUID_NOTIFY_ONLINE: "UUID_NOTIFY_ONLINE",
  UUID_NOTIFY_FARMING_SEA_FOOD: "UUID_NOTIFY_FARMING_SEA_FOOD",
  UUID_NOTIFY_AUTO_QUOC_CHIEN: "UUID_NOTIFY_AUTO_QUOC_CHIEN",
  UUID_NOTIFY_UPDATE_CONFIG: "UUID_NOTIFY_UPDATE_CONFIG",
  UUID_NOTIFY_UPDATE_EQUIPMENTS: "UUID_NOTIFY_UPDATE_EQUIPMENTS",
  UUID_NOTIFY_REMOVE_EQUIPMENTS: "UUID_NOTIFY_REMOVE_EQUIPMENTS",
  UUID_NOTIFY_AUTO_TRUC_LOC: "UUID_NOTIFY_AUTO_TRUC_LOC",
}
export const IDLE_TIMEOUT = {
  CLEAR_MAP_INFO: 15000,
  ENABLE_BUTTON_START_STOP: 1000,
  OFFLINE_STATUS: 17000,
  OFFLINE_STATUS_QC: 10000,
  CLEAR_STATUS_SELL_EQUIPMENT: 1000,
  CLEAR_STATUS_AUTO_TRUC_LOC: 2000,
}
export const BATTLE_RESULT = {
  BATTLING: 0,
  ATTACKER: 1,
  DEFENSER: 2,
  WIN: 3,
  FAIL: 4,
  EVEN: 5,
  UNKNOW: 6,
  CANCEL: 999,
  JOINED: 998,
  CREATED: 997,
  '0': 'BATTLING',
  '1': 'ATTACKER',
  '2': 'THUA',
  '3': 'WIN',
  '4': 'THUA',
  '5': 'EVEN',
  '6': 'UNKNOW',
  '999': 'CANCEL',
  '998': 'JOINED',
  '997': 'CREATED'
}

export const TIME_EVENT_QUOC_CHIEN = {
  "0": {
    DAY_OF_WEEK: 3,
    START_TIME: '19:29:00+07:00',
    END_TIME: '20:00:00+07:00',
  },
  "1": {
    DAY_OF_WEEK: 6,
    START_TIME: '19:29:00+07:00',
    END_TIME: '20:00:00+07:00',
  }
}

export const TIME_EVENT_TRUC_LOC = {
  START_TIME: '10:00:00+07:00',
  END_TIME: '22:00:00+07:00'
}
export const LIMIT_COUNT_TRUC_LOC_COMBAT = 1000;
export const LIMIT_LEVEL_TRUC_LOC = 200;
export const OPTION_SELECT_TRUC_LOC_COMBAT_COUNT = {
  lablel: "Lượt ghép",
  options: [
    { value: 0, label: 0 },
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
    { value: 500, label: 500 },
  ]
}

export const PLAYER_CONFIG = {
  ID_RETRY_MAX: 0,
  ID_AUTO_START_GAME: 1,
  ID_AUTO_NLC: 2,
  ID_AUTO_MIN_QL: 3,
  ID_START_GAME_AFTER_S: 4,
  ID_TOURNAMENT_DAILY_LIMIT: 5,
  ID_TAX_QUICK_COLLECT_LIMIT_GOLD: 6,
  ID_LIMIT_NLC: 7,
  ID_LIMIT_CA_VANG: 8,
  ID_LIMIT_SO: 9,
  ID_LIMIT_CA_NGU: 11,
  ID_LIMIT_MUC: 10,
  ID_LIMIT_TOM_HUM: 12,
  ID_LIMIT_CUA_HUYNH_DE: 13,
  ID_IS_START_JOIN: 14,
  ID_IS_START_CREATE: 15,
  ID_IS_BUY_QL_NLC: 16,
  ID_IS_FARM_HAI_SAN_RESET: 17,
  ID_IS_SEND_CHAT_ADS: 18,
  ID_AUTO_SALE_FOOD: 19,
  ID_AUTO_COUNTRY_WAR: 20,
  ID_PRIORITY_HAI_SAN: 21,
  ID_QC_ATK_CITY: 22,
  ID_AUTO_BUY_FOOD: 23,
  ID_OBJECT_LEGION_DROP_ITEM: 24,
  ID_AUTO_START_TRUC_LOC: 25,
  ID_QC_DEF_CITY: 26,

};

export const RESOURCES_ID = {
  ID_BAC: 1,
  ID_VANG: 2,
  ID_LUA: 3,
  ID_CHIEN_CONG: 4,
  ID_QUAN_LENH: 5,
  ID_TRANH_NGOC: 7,
  ID_CA_VANG: 118,
  ID_SO: 119,
  ID_CA_NGU: 120,
  ID_MUC: 121,
  ID_TOM_HUM: 122,
  ID_CUA_HUYNH_DE: 123,
  ID_NGOA_LONG_CUONG: 141,
  ID_LONG_DAN: 113,
  ID_DA_TOI_LUYEN: 20
}

export const OBJECT_REWARD_ITEM = {
  lablel: "Tài nguyên",
  options: [
    { value: -RESOURCES_ID.ID_CHIEN_CONG, label: "Chiến Công" },
    { value: -RESOURCES_ID.ID_TRANH_NGOC, label: "Tranh Ngọc" },
    { value: -RESOURCES_ID.ID_DA_TOI_LUYEN, label: "Đá Tôi Luyện" },
  ]
}

export const MAP_CONFIG_RESOURCE = {
  [PLAYER_CONFIG.ID_LIMIT_CA_VANG]: RESOURCES_ID.ID_CA_VANG,
  [PLAYER_CONFIG.ID_LIMIT_SO]: RESOURCES_ID.ID_SO,
  [PLAYER_CONFIG.ID_LIMIT_CA_NGU]: RESOURCES_ID.ID_CA_NGU,
  [PLAYER_CONFIG.ID_LIMIT_MUC]: RESOURCES_ID.ID_MUC,
  [PLAYER_CONFIG.ID_LIMIT_TOM_HUM]: RESOURCES_ID.ID_TOM_HUM,
  [PLAYER_CONFIG.ID_LIMIT_CUA_HUYNH_DE]: RESOURCES_ID.ID_CUA_HUYNH_DE
}
export const MAP_RESOURCE_CONFIG = {
  [RESOURCES_ID.ID_CA_VANG]: PLAYER_CONFIG.ID_LIMIT_CA_VANG,
  [RESOURCES_ID.ID_SO]: PLAYER_CONFIG.ID_LIMIT_SO,
  [RESOURCES_ID.ID_CA_NGU]: PLAYER_CONFIG.ID_LIMIT_CA_NGU,
  [RESOURCES_ID.ID_MUC]: PLAYER_CONFIG.ID_LIMIT_MUC,
  [RESOURCES_ID.ID_TOM_HUM]: PLAYER_CONFIG.ID_LIMIT_TOM_HUM,
  [RESOURCES_ID.ID_CUA_HUYNH_DE]: PLAYER_CONFIG.ID_LIMIT_CUA_HUYNH_DE
}
export const TIMEOUT_ONLINE = 15000;
export const TIMEOUT_FARMING_SEADFOOD = 5000;

export const HANDLE_EVENT_CHARACTER = {
  START_GAME: 'startGame',
  STOP_GAME: 'stopGame'
}

export const PLAYER_CONFIG_SEAFOOD = [
  PLAYER_CONFIG.ID_LIMIT_CA_VANG,
  PLAYER_CONFIG.ID_LIMIT_SO,
  PLAYER_CONFIG.ID_LIMIT_MUC,
  PLAYER_CONFIG.ID_LIMIT_CA_NGU,
  PLAYER_CONFIG.ID_LIMIT_TOM_HUM,
  PLAYER_CONFIG.ID_LIMIT_CUA_HUYNH_DE
]

export const PLAYER_CONFIG_QD_CHECKBOX = [
  PLAYER_CONFIG.ID_IS_START_JOIN,
  PLAYER_CONFIG.ID_IS_START_CREATE,
  PLAYER_CONFIG.ID_IS_BUY_QL_NLC,
  PLAYER_CONFIG.ID_AUTO_SALE_FOOD,
  PLAYER_CONFIG.ID_AUTO_BUY_FOOD,
  PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR,
  PLAYER_CONFIG.ID_AUTO_START_GAME
]

export const PLAYER_CONFIG_QD_NUMBER = [
  PLAYER_CONFIG.ID_AUTO_MIN_QL
]

export const PLAYER_CONFIG_QD_SELECT = [
  PLAYER_CONFIG.ID_START_GAME_AFTER_S
]

export const PLAYER_CONFIG_LABEL = {
  [PLAYER_CONFIG.ID_AUTO_START_GAME]: 'Tự login',
  [PLAYER_CONFIG.ID_START_GAME_AFTER_S]: 'Sau N phút',
  [PLAYER_CONFIG.ID_IS_START_JOIN]: 'Join quân đoàn',
  [PLAYER_CONFIG.ID_IS_START_CREATE]: 'Tạo quân đoàn',
  [PLAYER_CONFIG.ID_IS_BUY_QL_NLC]: 'Tự mua quân lệnh',
  [PLAYER_CONFIG.ID_AUTO_SALE_FOOD]: 'Tự bán lúa',
  [PLAYER_CONFIG.ID_AUTO_BUY_FOOD]: 'Tự mua lúa',
  [PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR]: 'Auto quốc chiến',
  [PLAYER_CONFIG.ID_QC_ATK_CITY]: 'Công',
  [PLAYER_CONFIG.ID_QC_DEF_CITY]: 'Thủ',
  [PLAYER_CONFIG.ID_AUTO_MIN_QL]: 'Min quân lệnh',
  [PLAYER_CONFIG.ID_PRIORITY_HAI_SAN]: 'Ưu tiên',
  [PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET]: 'Tự càn quét giờ reset',
  [PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM]: 'Join QĐ rớt trang bị',
  [PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT]: 'Số lượt sẽ ghép'
}

export const PLAYER_CONFIG_TIP = {
  [PLAYER_CONFIG.ID_AUTO_START_GAME]: 'Tự động start lại sau khi bị disconnect. Chỉ khả dụng cho kiểu đăng nhập dùng username và password',
  [PLAYER_CONFIG.ID_START_GAME_AFTER_S]: 'Kể từ thời điểm bị disconnect, sau N phút sẽ tự start lại auto',
  [PLAYER_CONFIG.ID_IS_START_JOIN]: 'Tự động tham gia quân đoàn. Nếu bỏ chọn thì sẽ chỉ tham gia quân đoàn lần đầu',
  [PLAYER_CONFIG.ID_IS_START_CREATE]: 'Tự động tạo quân đoàn. Chỉ khả dụng trong thời gian rớt Ngọa Long Chương',
  [PLAYER_CONFIG.ID_IS_BUY_QL_NLC]: 'Tự mua quân lệnh trong Quà Ngọa Long khi quân lệnh dưới 100 lệnh. Giá 50v/30QL. Tối đa 500 lượt mua',
  [PLAYER_CONFIG.ID_AUTO_SALE_FOOD]: 'Tự bán lúa chợ đen nếu giá > 7 và trạng thái đang giảm',
  [PLAYER_CONFIG.ID_AUTO_BUY_FOOD]: 'Tự mua lúa chợ đen nếu giá < 0.7 và trạng thái đang tăng',
  [PLAYER_CONFIG.ID_AUTO_COUNTRY_WAR]: 'Tự tham gia quốc chiến vào mỗi thứ 4 và thứ 7 19h30 ~ 20h',
  [PLAYER_CONFIG.ID_QC_ATK_CITY]: 'Trong auto Quốc Chiến sẽ tự tấn công thành trì này',
  [PLAYER_CONFIG.ID_QC_DEF_CITY]: 'Trong auto Quốc Chiến sẽ thủ thành trì này. Nếu không có địch sẽ chuyển sang tấn công thành trì địch',
  [PLAYER_CONFIG.ID_AUTO_MIN_QL]: 'Khả dụng ngoài sự kiện rớt Ngọa Long Chương. Khi thiết lập tự join quân đoàn, Nếu quân lệnh còn lại dưới min quân lệnh thì sẽ không tự join quân đoàn',
  [PLAYER_CONFIG.ID_PRIORITY_HAI_SAN]: 'Số càng thấp ưu tiên càng cao',
  [PLAYER_CONFIG.ID_LIMIT_CA_VANG]: 'Thiết lập số lượng hải sản tổng tối đa của tuần. Khi đạt số lượng thiết lập thì sẽ bỏ qua càn quét hải sản tương ứng',
  [PLAYER_CONFIG.ID_LIMIT_SO]: 'Thiết lập số lượng hải sản tổng tối đa của tuần. Khi đạt số lượng thiết lập thì sẽ bỏ qua càn quét hải sản tương ứng',
  [PLAYER_CONFIG.ID_LIMIT_CA_NGU]: 'Thiết lập số lượng hải sản tổng tối đa của tuần. Khi đạt số lượng thiết lập thì sẽ bỏ qua càn quét hải sản tương ứng',
  [PLAYER_CONFIG.ID_LIMIT_MUC]: 'Thiết lập số lượng hải sản tổng tối đa của tuần. Khi đạt số lượng thiết lập thì sẽ bỏ qua càn quét hải sản tương ứng',
  [PLAYER_CONFIG.ID_LIMIT_TOM_HUM]: 'Thiết lập số lượng hải sản tổng tối đa của tuần. Khi đạt số lượng thiết lập thì sẽ bỏ qua càn quét hải sản tương ứng',
  [PLAYER_CONFIG.ID_LIMIT_CUA_HUYNH_DE]: 'Thiết lập số lượng hải sản tổng tối đa của tuần. Khi đạt số lượng thiết lập thì sẽ bỏ qua càn quét hải sản tương ứng',
  [PLAYER_CONFIG.ID_IS_FARM_HAI_SAN_RESET]: 'Sẽ tự động càn quét hải sản tại các giờ reset 9h30, 12h30, 19h, 21h',
  [PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM]: 'Khả dụng ngoài sự kiện rớt Ngọa Long Chương. Chỉ tham gia những quân đoàn rớt tài nguyên được chọn',
  [PLAYER_CONFIG.ID_TOURNAMENT_DAILY_LIMIT]: 'Chọn số trận sẽ ghép',
}

export const PLAYER_CONFIG_IMAGE = {
  [PLAYER_CONFIG.ID_LIMIT_CA_VANG]: imgCavang,
  [PLAYER_CONFIG.ID_LIMIT_SO]: imgSo,
  [PLAYER_CONFIG.ID_LIMIT_CA_NGU]: imgCangu,
  [PLAYER_CONFIG.ID_LIMIT_MUC]: imgMuc,
  [PLAYER_CONFIG.ID_LIMIT_TOM_HUM]: imgTomhum,
  [PLAYER_CONFIG.ID_LIMIT_CUA_HUYNH_DE]: imgcua,
}
export const TYPE_UI = {
  CHECK_BOX: 1,
  INPUT_NUMBER: 2,
  CHECK_BOX_INPUT_NUMBER: 3,
  SELECT_BOX: 4,
  CHECK_BOX_SELECT_BOX: 5
}
export const PLAYER_CONFIG_TYPE_UI = [
  {
    TYPE: TYPE_UI.CHECK_BOX,
    ID_1: PLAYER_CONFIG.ID_IS_START_CREATE
  },
  {
    TYPE: TYPE_UI.CHECK_BOX,
    ID_1: PLAYER_CONFIG.ID_IS_BUY_QL_NLC
  },
  {
    TYPE: TYPE_UI.CHECK_BOX,
    ID_1: PLAYER_CONFIG.ID_AUTO_SALE_FOOD
  },
  {
    TYPE: TYPE_UI.CHECK_BOX,
    ID_1: PLAYER_CONFIG.ID_AUTO_BUY_FOOD
  },
  {
    TYPE: TYPE_UI.CHECK_BOX_INPUT_NUMBER,
    ID_1: PLAYER_CONFIG.ID_IS_START_JOIN,
    ID_2: PLAYER_CONFIG.ID_AUTO_MIN_QL,
    ID_2_MIN: 0
  },
  {
    TYPE: TYPE_UI.CHECK_BOX_INPUT_NUMBER,
    ID_1: PLAYER_CONFIG.ID_AUTO_START_GAME,
    ID_2: PLAYER_CONFIG.ID_START_GAME_AFTER_S,
    ID_2_MIN: 10
  },
  {
    TYPE: TYPE_UI.SELECT_BOX,
    ID_1: PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM,
  }
]
export const COLLAPSE = {
  ALL_CLOSE: -1,
  QUOC_CHIEN: 0,
  FARM_TRANG_BI: 1,
  HAI_SAN: 2,
  SELL_EQUIPMENTS: 3,
  TRUC_LOC: 4,
  HOAT_DONG: 5,
}

export const CONST_TOOLTIP = {
  SELL_EQUIPMENTS: 'Số lượng trang bị có level 1',
}

export const HAI_SAN_PRIORITY_DEFAULT = [PLAYER_CONFIG.ID_LIMIT_CA_VANG, PLAYER_CONFIG.ID_LIMIT_SO, PLAYER_CONFIG.ID_LIMIT_MUC, PLAYER_CONFIG.ID_LIMIT_CA_NGU, PLAYER_CONFIG.ID_LIMIT_TOM_HUM, PLAYER_CONFIG.ID_LIMIT_CUA_HUYNH_DE]
